import { Breadcrumb, SimpleCard } from "app/components";
import React, { useCallback, useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import {
  Button,
  Icon,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Grid,
  Box,
  Typography,
  Divider,
} from "@material-ui/core";
import axios from "axios.js";
import { useHistory } from "react-router-dom";
import { config } from "../../../../config";
import ConfirmMessage from "../../Configuration/Message/ConfirmMessage";
import { toast } from "react-toastify";

const AccountHeadList = () => {
  const history = useHistory();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [reqBody, setReqBody] = useState({});
  const [loading, setLoading] = useState(true);
  const [accountHeadObj, setAccountHeadObj] = useState({});
  const [confirmMessage, setConfirmMessage] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchAPI = useCallback(
    async (body) => {
      let response = await axios.post(config.BASE_API + "/AccountHead/Search", {
        page: page,
        rowsPerPage: rowsPerPage,
        keyword: body?.keyword,
      });
      response = await response.data;
      setAccountHeadObj(response.data);
      setLoading(false);
      if (response?.succeeded === false) {
        toast.error(response.message);
      }
    },
    [page, rowsPerPage]
  );

  const handleSearch = (event) => {
    if (event?.nativeEvent?.submitter?.name === "search") {
      fetchAPI(reqBody);
    } else {
      print(reqBody);
    }
  };

  function print(item) {
    axios({
      url: config.BASE_API + "/Expense/print",
      method: "post",
      data: { keyword: item?.keyword },
      responseType: "blob", // important
    }).then((response) => {
      if (response?.data?.type === "text/plain") {
        window.alert("No Result Found");
        return;
      }
      const url = window.URL.createObjectURL(new Blob([response?.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.pdf");
      document.body.appendChild(link);
      link.click();
    });
  }
  const handleChange = (event) => {
    event.persist();
    setReqBody({
      ...reqBody,
      [event.target.name]: event.target.value,
    });
  };
  const { keyword } = reqBody;

  useEffect(() => {
    fetchAPI(reqBody);
  }, [fetchAPI]);

  return (
    <>
      <div className="m-sm-30">
        <div className="mb-sm-30">
          <Breadcrumb
            routeSegments={[
              {
                name: "Account",
                path: "/account-head/account-head-list",
              },
              { name: "Account List" },
            ]}
          />
        </div>
        <ValidatorForm onSubmit={handleSearch} onError={() => null}>
          <Box marginBottom={2}>
            <SimpleCard>
              <TextField
                className="mr-3"
                label="Search By Keywords"
                name="keyword"
                size="small"
                variant="outlined"
                value={keyword || ""}
                onChange={handleChange}
                style={{ marginTop: 10 }}
              />

              <Button
                variant="contained"
                color="primary"
                type="submit"
                name="search"
                style={{ marginTop: 10 }}
              >
                Search
              </Button>
              {/* <Button
                variant="contained"
                color="primary"
                type="submit"
                name="print"
                style={{ marginTop: 10, marginLeft: 10 }}
              >
                Download Pdf
              </Button> */}
            </SimpleCard>
          </Box>

          {loading ? (
            "Loading"
          ) : (
            <SimpleCard>
              <Grid container justify="space-between" alignItems="flex-start">
                <Grid item>
                  <Box marginBottom={2}>
                    <Typography variant="h6">Account List</Typography>
                  </Box>
                </Grid>
                <Grid item>
                  <Box marginBottom={2}>
                    <Button
                      color="primary"
                      variant="contained"
                      size="small"
                      onClick={() =>
                        history.push("/account-head/account-head/addNew")
                      }
                    >
                      + Add New Account
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              <Divider style={{ background: "gray" }} variant="middle" />
              <div className="w-full overflow-auto">
                <TableContainer style={{ width: "100%", overflowX: "auto" }}>
                  <Table style={{ minWidth: 1500 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell className="px-0">Id</TableCell>
                        <TableCell className="px-0">Code</TableCell>
                        <TableCell className="px-0">Name</TableCell>
                        <TableCell className="px-0">Account Type</TableCell>
                        <TableCell className="px-0">Level</TableCell>
                        <TableCell className="px-0">Parent</TableCell>
                        <TableCell className="px-0">Is Control?</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {accountHeadObj?.item1.map((subscriber, index) => (
                        <TableRow key={index}>
                          <TableCell className="px-0 capitalize" align="left">
                            {subscriber.id}
                          </TableCell>
                          <TableCell className="px-0 capitalize" align="left">
                            {subscriber.code}
                          </TableCell>
                          <TableCell className="px-0 capitalize" align="left">
                            {subscriber.name}
                          </TableCell>
                          <TableCell className="px-0 capitalize" align="left">
                            {subscriber.accountTypeName}
                          </TableCell>
                          <TableCell className="px-0 capitalize" align="left">
                            {subscriber.level}
                          </TableCell>
                          <TableCell className="px-0 capitalize" align="left">
                            {subscriber.parentName}
                          </TableCell>
                          <TableCell className="px-0 capitalize" align="left">
                            {subscriber.isControlAccount ? "Y" : "N"}
                          </TableCell>
                          <TableCell className="px-0">
                            <IconButton
                              onClick={() => {
                                history.push("/account-head/" + subscriber.id);
                              }}
                            >
                              <Icon color="primary">edit</Icon>
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <ConfirmMessage
                  confirmMessage={confirmMessage}
                  setConfirmMessage={setConfirmMessage}
                />

                <TablePagination
                  className="px-4"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  component="div"
                  count={accountHeadObj?.item2}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  backIconButtonProps={{
                    "aria-label": "Previous Page",
                  }}
                  nextIconButtonProps={{
                    "aria-label": "Next Page",
                  }}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </div>
            </SimpleCard>
          )}
        </ValidatorForm>
      </div>
    </>
  );
};

export default AccountHeadList;
